export enum LikesEnum {
  DESIGN = "design",
  MATERIAL = "material",
  PRICE = "price",
}
